<template>
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title" :title1="title1" />
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-6 col-sm-6 col-12">
                <div class="form-group">
                  <label>Unit Name</label>
                  <b-form-input type="text" v-model="form.unitname" ref="firstInput" @keypress.enter="submitForm()" />
                </div>
              </div>
              <div class="col-lg-6 col-sm-6 col-12">
                <div class="form-group">
                  <label>Unit Code</label>
                  <b-form-input type="text" v-model="form.unitcode" @keypress.enter="submitForm()" />
                </div>
              </div>
              <div class="col-lg-12">
                <div class="form-group">
                  <label>Description</label>
                  <b-form-textarea
                    id="textarea"
                    v-model="form.description"
                    rows="3"
                    max-rows="6"
                    @keypress.enter="submitForm()"
                  ></b-form-textarea>
                </div>
              </div>

              <div class="col-lg-12">
                <a v-on:click="postData()" class="btn btn-submit me-2">Submit</a>
                <router-link to="unitlist" class="btn btn-cancel">Cancel</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.post["Content-Type"] = "application/json;charset=utf-8";

export default {
  data() {
    return {
      form: {
        unitname: "",
        unitcode: "",
        description: "",
      },
      title: "Item Add Unit",
      title1: "Create new item unit",
    };
  },
  methods: {
    async postData() {
      if (!this.form.unitname) {
        Swal.fire("Please enter the unit name");
        return;
      }
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "Do you really want to submit the form?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, submit it!",
      });

      if (!result.isConfirmed) return;
      axios
        .post("/v1/units", this.form)
        .then(() => {
          Swal.fire("Unit created successfully");
          this.$router.push({ path: "/unitlist" });
        })
        .catch((error) => {
          console.log(error);
          Swal.fire(error.response?.data?.detail || "Could not create unit");
        });
    },
    submitForm() {
      this.postData();
    },
  },
  mounted() {
    this.$refs.firstInput.focus();
  },
  name: "addunit",
};
</script>
